module.exports = __webpack_public_path__ + "static/media/480.d0b16904.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-harness/dark/480.png
// module id = 2136
// module chunks = 2